import React, { useState } from 'react';
import '../Assets/Css/product.css';
import { Container, Row, Col, Card, Button, Modal, Image } from 'react-bootstrap';

import tech1 from '../Assets/Image/tech-doppler.png';
import tech2 from '../Assets/Image/tech-optics.png';
import tech3 from '../Assets/Image/tech-extrusion.png';
import tech4 from '../Assets/Image/tech-bioavailable.png'; 
import { Helmet } from 'react-helmet';

// Import your three related images per tech
import radar1 from '../Assets/Image/radar1.png';
import radar2 from '../Assets/Image/radar2.png';
// import radar3 from '../Assets/Image/radar3.png';

import optics1 from '../Assets/Image/optics1.png';
import optics2 from '../Assets/Image/optics2.png';
// import optics3 from '../Assets/Image/optics3.png';

import extra1 from '../Assets/Image/extra1.png';
import extra2 from '../Assets/Image/extra2.png';
// import extra3 from '../Assets/Image/extra3.png';

import bio1 from '../Assets/Image/bio1.png';
import bio2 from '../Assets/Image/bio2.png';
// import bio3 from '../Assets/Image/bio3.png';

export default function ProductPage() {
  const [showModal, setShowModal] = useState(false);
  const [selectedTech, setSelectedTech] = useState(null);
  const [currentImg, setCurrentImg] = useState(null);

  const technologies = [
    {
      img: tech1,
      title: "Doppler Radar",
      desc: "Our Doppler Radar systems are engineered for high-precision environmental sensing applications such as agriculture, weather forecasting, and security. These radar units utilize frequency shift technology to provide accurate, real-time data in a variety of weather and terrain conditions.",
      points: ["Custom Frequency Tuning", "Rugged Outdoor Use", "Data Integration Capabilities","Real-time motion and velocity tracking","Customizable frequency bands for targeted applications","Weatherproof housing for rugged outdoor deployment","Seamless data integration with IoT and analytics platforms","Long-range detection with minimal interference"],
      relatedImgs: [tech1 ,radar1, radar2]
    },
    {
      img: tech2,
      title: "Optics / Mirrors",
      desc: "Sense Technologies designs high-precision optics and mirrors for use in industrial automation, scientific research, and sensor systems. Our components deliver optimized reflectivity and durability across a broad spectrum of wavelengths.",
      points: ["High-Precision Glass", "Reflectivity Optimization", "Wide Wavelength Support","Custom curvature and coating options","Durable under extreme lab/field conditions","Broad spectrum compatibility (UV to IR)"],
      relatedImgs: [ tech2, optics1, optics2]
    },
    {
      img: tech3,
      title: "Extrusion & Expelling",
      desc: "Our extrusion and expelling systems are engineered for the efficient processing of oilseeds, grains, and plant biomass. The technology is optimized for maximum yield, energy efficiency, and product purity — ideal for clean-label nutrition and sustainable production.",
      points: ["Cold Press Tech", "Energy Efficient", "Modular Design","Adaptable for different seed types","High oil recovery efficiency"],
      relatedImgs: [ tech3, extra1, extra2]
    },
    {
      img: tech4,
      title: "Bioavailable Nutrient-Dense Proteins",
      desc: "We develop plant-based protein systems that enhance bioavailability, nutritional content, and digestion. Designed for use in food, supplements, and functional nutrition, our proteins support wellness and sustainability without compromise.",
      points: ["High Absorption Rate", "Clean Label Ingredients", "Sustainable Sourcing","Protein isolates from peas, lentils, hemp, etc.","Designed for muscle recovery & metabolism","Excellent solubility and taste profile"],
      relatedImgs: [ tech4,bio1, bio2]
    }
  ];

  const handleShow = (tech) => {
    setSelectedTech(tech);
    setCurrentImg(tech.img);   // start with the main image
    setShowModal(true);
  };
  const handleClose = () => setShowModal(false);

  return (
    <>
      <div className='py-2'>
        <Helmet>
        <title>Our Technologies | Sense Technologies, Inc.</title>
        <meta 
          name="description" 
          content="Explore the advanced technologies developed by Sense Technologies, Inc. including Doppler Radar, Optics/Mirrors, Extrusion & Expelling, and Bioavailable Nutrient-Dense Proteins." 
        />
        <meta 
          name="keywords" 
          content="Doppler Radar, Optics, Mirrors, Extrusion, Expelling, Nutrient Dense Proteins, bioavailable technology, sustainable innovation" 
        />
        <meta name="author" content="Sense Technologies, Inc." />

        {/* Open Graph for Facebook/LinkedIn */}
        <meta property="og:title" content="Our Technologies | Sense Technologies, Inc." />
        <meta 
          property="og:description" 
          content="Learn about our innovations in Doppler Radar, optics, natural protein extraction, and more." 
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://sensenaturalproducts.com/technologies" />
        <meta property="og:image" content="https://sensenaturalproducts.com/images/tech-preview.jpg" />

        {/* Twitter Card */}
        <meta name="twitter:title" content="Our Technologies | Sense Technologies, Inc." />
        <meta 
          name="twitter:description" 
          content="Discover our leading-edge work in radar sensing, optical tech, protein science, and natural manufacturing processes." 
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://sensenaturalproducts.com/images/tech-twitter.jpg" />

        <link rel="canonical" href="https://sensenaturalproducts.com/technologies" />
      </Helmet>
         <Container  >
        <h2 className="Mainhead mb-4 text-center">Our Technologies</h2>
        <Row className="g-4">
          {technologies.map((tech, idx) => (
            <Col md={3} key={idx}>
             <Card className="custom-card text-center h-100 shadow-sm">
  <Card.Img
    variant="top"
    src={tech.img}
    alt={tech.title}
    style={{ height: '200px', objectFit: 'cover' }}
  />
  <Card.Body className="d-flex flex-column">
    <h6 className="fw-bold">{tech.title}</h6>
    <div className="mt-auto">
      <Button className="btn-darkbrown w-50" onClick={() => handleShow(tech)}>
        View Details <span>&raquo;</span>
      </Button>
    </div>
  </Card.Body>
</Card>


            </Col>
          ))}
        </Row>
      </Container>
      </div>
     

      <Modal show={showModal} onHide={handleClose} size="lg" centered className='pt-4'>
        <Modal.Header closeButton>
          <Modal.Title>{selectedTech?.title}</Modal.Title>
        </Modal.Header>
<Modal.Body>
  {selectedTech && (
    <Row>
      {/* LEFT COLUMN: Main image + thumbnails */}
      <Col md={5}>
        <Image
          src={currentImg}
          alt="Main Tech Image"
          fluid
          rounded
          className="mb-5"
          style={{height: '300px',width:'100%', objectFit: 'cover' }}
        />

        <Row className="g-2 justify-content-center">
          {selectedTech?.relatedImgs?.map((thumbSrc, i) => (
            <Col xs={4} key={i}>
              <Image
                src={thumbSrc}
                thumbnail
                onClick={() => setCurrentImg(thumbSrc)}
                style={{
                  height: '60px',
                  width: '100%',
                  objectFit: 'cover',
                  cursor: 'pointer',
                  border: currentImg === thumbSrc ? '2px solid #dc3545' : ''
                }}
              />
            </Col>
          ))}
        </Row>
      </Col>

      {/* RIGHT COLUMN: Description + Features */}
      <Col md={7}>
        <h6 className="text-dark fw-bold fs-5 mt-2">Description:</h6>
        <p style={{  color: '#333' }}>{selectedTech.desc}</p>

        <h6 className="text-dark fw-bold mt-3 fs-5">Features:</h6>
        <ul style={{  paddingLeft: '1.4rem' }}>
          {selectedTech.points.map((pt, i) => (
            <li key={i} style={{ marginBottom: '6px' }}>{pt}</li>
          ))}
        </ul>
      </Col>
    </Row>
  )}
</Modal.Body>



       
      </Modal>
    </>
  );
}
